export const CHOICE_ID_CANCEL = 'cancel'
export const CHOICE_ID_NO = 'no'
export const CHOICE_ID_OK = 'ok'
export const CHOICE_ID_YES = 'yes'

export const OK_PROMPT_CHOICES = [
  {
    choiceId: CHOICE_ID_OK,
    buttonText: 'OK'
  }
]

export const CANCEL_PROMPT_CHOICES = [
  {
    choiceId: CHOICE_ID_CANCEL,
    buttonText: 'Cancel'
  }
]

export const OK_CANCEL_PROMPT_CHOICES = OK_PROMPT_CHOICES.concat(
  CANCEL_PROMPT_CHOICES
)

export const YES_NO_PROMPT_CHOICES = [
  {
    choiceId: CHOICE_ID_YES,
    buttonText: 'Yes'
  },
  {
    choiceId: CHOICE_ID_NO,
    buttonText: 'No'
  }
]

export const ROUTE_CHANGE_RESPONSE_ALLOW = 'allow'
export const ROUTE_CHANGE_RESPONSE_BLOCK = 'block'
export const ROUTE_CHANGE_RESPONSE_UNSAVED_PROMPT = 'unsaved-prompt'
